import { TableContainer } from "@mui/material";
import Paper from "@mui/material/Paper";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import LeftSideNav from "../../../Components/LeftSideNav";
import Loader from "../../../Components/Loader";
import TopNavBar from "../../../Components/TopNavbar";
import Strings from "../../../Config/Strings";
import {
  addToUserAPI,
  addUserAdditionalInfoAnswerValueAPI,
  getUserAdditionalInfoQuestionIdAPI,
} from "../../../Store/Action/UserAction";
import UserForm from "./Controller/UserForm";

const AddUser = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gstCheckboxQuestionId, setGstCheckboxQuestionId] = useState(null);
  const [gstNumberQuestionId, setGstNumberQuestionId] = useState(null);
  const [companyPanNumberQuestionId, setCompanyPanNumberQuestionId] = useState(null);
  const [companyDocumentNumberQuestionId, setCompanyDocumentNumberQuestionId] = useState(null);
  const [pinCodeQuestionId, setPinCodeQuestionId] = useState(null);

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/", text: "Customers" },
      { key: "2", href: "/addUser", text: "Add Customer" },
    ]);
    dispatch(
      getUserAdditionalInfoQuestionIdAPI({}, (result) => {
        if (result && Array.isArray(result)) {
          const gstCheckboxOptions = result?.find(
            (item) => item?.generic_name === "gstCheckbox"
          );
          const gstNumberQuestionInfo = result?.find(
            (item) => item?.generic_name === "gstNumber"
          );
          const companyDocumentNumberInfo = result?.find(
            (item) => item?.generic_name === "companyDocumentNumber"
          );
          const companyPanNumberInfo = result?.find(
            (item) => item?.generic_name === "companyPanNumber"
          );
          const pinCodeInfo = result?.find(
            (item) => item?.generic_name === "pincode"
          );
          setGstNumberQuestionId(
            gstNumberQuestionInfo.user_additional_information_id
          );
          setCompanyDocumentNumberQuestionId(
            companyDocumentNumberInfo.user_additional_information_id
          );
          setCompanyPanNumberQuestionId(
            companyPanNumberInfo.user_additional_information_id
          );
          setPinCodeQuestionId(
            pinCodeInfo.user_additional_information_id
          );
          setGstCheckboxQuestionId(
            gstCheckboxOptions.user_additional_information_id
          );
        }
      })
    );
  }, [dispatch]);

  const onSubmit = async ({
    formData,
    user_state,
    user_city,
    user_role_id,
    gst_checkbox_option,
  }) => {
    const requestData = {};
    formData.forEach((value, key) => {
      requestData[key] = value;
    });
    requestData.user_state = user_state;
    requestData.user_city = user_city;
    requestData.user_role_id = user_role_id;

    const userAdditionalInfoData = [
      {
        user_additional_information_id: gstCheckboxQuestionId,
        user_additional_information_data_value: gst_checkbox_option,
      },
    ];

    // Conditionally add GST or Company Document Number
    if (gst_checkbox_option === "yes") {
      userAdditionalInfoData.push({
        user_additional_information_id: gstNumberQuestionId,
        user_additional_information_data_value: requestData["GST_No"],
      });
    } else if (gst_checkbox_option === "no") {
      userAdditionalInfoData.push({
        user_additional_information_id: companyDocumentNumberQuestionId,
        user_additional_information_data_value: requestData["company_doc_no"],
      });
    }

    userAdditionalInfoData.push({
      user_additional_information_id: companyPanNumberQuestionId,
      user_additional_information_data_value: requestData["pan_card_no"],
    });

    userAdditionalInfoData.push({
      user_additional_information_id: pinCodeQuestionId,
      user_additional_information_data_value: requestData["pin_code"],
    });

    try {
      await dispatch(
        addToUserAPI(requestData, (isSuccess, response) => {
          setLoading(false);
          if (isSuccess?.status === true) {
            dispatch(
              addUserAdditionalInfoAnswerValueAPI(
                userAdditionalInfoData,
                (isSuccess, response) => {
                  if (isSuccess?.status === true) {
                    toast.success("User Added Successfully");
                    navigate("/userList");
                  } else {
                    toast.error(
                      response?.error?.message ||
                        Strings.somethingWentWrongError
                    );
                  }
                }
              )
            );
          } else {
            toast.error(
              response?.error?.message || Strings.somethingWentWrongError
            );
          }
        })
      );
    } catch (error) {
      setLoading(false);
      console.log("Error dispatching addToUserAPI:", error);
      toast.error("An unexpected error occurred. Please try again.");
    }
  };

  return (
    <div style={mainContainer}>
      <LeftSideNav />

      <div style={leftNavContainer}>
        <div style={topBar}>
          <TopNavBar leftSideText="Add Customer" />
          <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
        </div>

        <TableContainer component={Paper} style={tableContainer}>
          <UserForm onSubmit={onSubmit} />
        </TableContainer>
      </div>

      <Loader loading={loading} />
    </div>
  );
};

const mainContainer = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100vh",
  width: "100vw",
  overflowX: "hidden",
  overflowY: "hidden",
};

const leftNavContainer = {
  display: "grid",
  gridTemplateRows: "15% 80%",
  backgroundColor: "#F0F5FF",
};

const topBar = {
  backgroundColor: "white",
  height: "7vh",
  width: "100%",
};

const tableContainer = {
  width: "75vw",
  border: "1px solid #ccc",
  borderRadius: "15px",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  marginTop: "20px",
  paddingRight: "20px",
  marginLeft: "20px",
};


export default AddUser;
